import { MDSIcon, MDSIconKind, MDSCollectionIcon } from "@/mds/components/icon";
import {
  MDSTextColor,
  MDSTextOverflow,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds/components/text";
import { StyledDialogChip, StyledIconContainer, StyledLabelText } from "./dialog-chip.style";
import { MDSDialogChipProps, MDSDialogChipVariant } from "./dialog-chip.types";

export const MDSDialogChip = (props: MDSDialogChipProps) => {
  const { label, inline, variant, ...rest } = props;
  const collectionId = variant === MDSDialogChipVariant.Collection ? props.collectionId : undefined;

  const icon = (() => {
    switch (variant) {
      case MDSDialogChipVariant.Collection:
        return <MDSCollectionIcon size={16} boxSize={16} collectionId={collectionId} />;
      case MDSDialogChipVariant.Template:
        return <MDSIcon kind={MDSIconKind.Template} size={16} boxSize={16} />;
      case MDSDialogChipVariant.Note:
      default:
        return <MDSIcon kind={MDSIconKind.Document} size={16} boxSize={16} />;
    }
  })();

  return (
    <StyledDialogChip $inline={inline} {...rest} data-mds-name="dialog-chip">
      <StyledIconContainer $inline={inline}>{icon}</StyledIconContainer>
      <StyledLabelText
        $inline={inline}
        variant={MDSTextVariant.HeaderL}
        weight={MDSTextWeight.SemiBold}
        color={MDSTextColor.Contrast}
        overflow={MDSTextOverflow.Ellipsis}
      >
        {label}
      </StyledLabelText>
    </StyledDialogChip>
  );
};
